// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b7321b1e","37":"6753ad36","98":"d44cee9a","147":"546b1bc3","171":"c5cce319","429":"13113819","453":"fd93b48e","466":"901359dd","507":"64167321","594":"2d090b83","718":"4288d796","780":"b4621c41"}[chunkId] + ".chunk.js";
};